import ReactMarkdown from 'react-markdown';

import styled from 'styled-components';
import { customMedia } from '../../utils/breakpoints'

export const Container = styled.div`
  padding: 8px;
  border-radius: 8px;
  border: 1px solid #1616163d;
  background: #fefefe;
  display: flex;
  align-items: flex-start;
  gap: 4px;
  box-shadow:
    0px 16px 40px 0px #16161614,
    0px 8px 8px 0px #1616160a;
  position: fixed;
  z-index: 1100;
  right: 80px;
  bottom: 32px;
  
  ${customMedia.lessThan('xs')`
    right: 72px;
    bottom: 65px;
  `}
`;

export const Content = styled(ReactMarkdown)`
  max-width: 180px;
  word-wrap: break-word;

  p {
    font-size: 14px;
    line-height: 170%;
    color: #161616;
  }

  strong {
    font-weight: 700;
  }
`;

export const CloseBtn = styled.div`
  cursor: pointer;
`;
